module.exports = __webpack_public_path__ + "img/rforum64_ua.63f732e9.webp";